import React, {useState} from "react";
import clinicService from "../../../../../services/clinic.service";
import {toast} from "react-toastify";
import AddCustomization from "./AddCustomization";
import {useParams} from "react-router-dom";


function CustomizationForm({customization, updateCustomization}) {
    const [customValue, setCustomValue] = useState(customization);
    const {clinicId} = useParams();
    const [modify, setModify] = useState(false);
    const [copied, setCopied] = useState(null);

    const handleDelete = (item) => {
        // console.log(item)
        clinicService
            .deleteCustomization(item.clinicId, item.id)
            .then((res) => {
                // console.log(res)
                const updatedValues = customValue.filter((cv) => cv.id !== item.id);
                setCustomValue(updatedValues);
                toast.success("Deleted Customization", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            })
            .catch((err) => {
                // console.log(err);
                toast.error("Error While Deleting", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
            });
    };
    const handleEdit = (item, source, mytarget) => {
        const updatedValues = customValue.map((cv) => {
            if (source === "optionkey" && cv.id === item.id) {
                return {...cv, optionKey: mytarget.target.value};
            }
            if (source === "optionvalue" && cv.id === item.id) {
                return {...cv, optionValue: mytarget.target.value};
            }
            return {...cv};
        });

        // console.log(updatedValues);
        setCustomValue(updatedValues);
    };
    const handleModify = () => {
        setModify(!modify);
    };
    const handleSave = () => {
        //console.log(customValue);
        clinicService
            .updateCustomization(clinicId, customValue)
            .then((res) => {
                // console.log("Updated Customization");
                // console.log(res.data);
                toast.success("Saved", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                });
                updateCustomization(res.data);
            })
            .catch((err) => {
                // console.log("Error");
                // console.log(err);
            });
        setModify(!modify);
    };


    const copyToClipboard = (id) => {
        navigator.clipboard.writeText(id)
            .then(() => {
                setCopied(id);
                setTimeout(() => setCopied(null), 2000); // Reset after 2 seconds
            })
            .catch(err => {
                console.error('Failed to copy: ', err);
            });
    };

    const handleCustomAdd = (newCustomValue) => {
        updateCustomization(newCustomValue)
        // console.log(newCustomValue)
        setCustomValue([...customValue, newCustomValue[0]])
    }
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-8">
                        <table className="table table-striped">
                            <thead>
                            <tr>
                                <th>Key</th>
                                <th>Value</th>
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            {customValue.map((item) => {
                                return (
                                    <tr key={item.id}>
                                        <td>
                                            {modify ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={item.optionKey}
                                                    onChange={(i) => handleEdit(item, "optionkey", i)}
                                                />
                                            ) : (
                                                item.optionKey
                                            )}
                                        </td>
                                        <td>
                                            {modify ? (
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={item.optionValue}
                                                    onChange={(i) => handleEdit(item, "optionvalue", i)}
                                                />
                                            ) : (
                                                item.optionValue
                                            )}
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm"
                                                onClick={() => handleDelete(item)}
                                                title="Delete Customize item"
                                            >
                                                <i className="bi bi-trash"></i>
                                            </button>
                                            <button
                                                onClick={() => copyToClipboard(item.id)}
                                                className="btn btn-sm btn-outline-primary"
                                                title="Copy ID to clipboard"
                                            >
                                                {copied === item.id ? (
                                                    <i className="bi bi-check2"></i>
                                                ) : (
                                                    <i className="bi bi-copy"></i>
                                                )}
                                            </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>
                    </div>
                    <div className="col-4">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex flex-column mt-3">
                                    {modify ? (
                                        <button
                                            type="button"
                                            className="btn btn-success btn-sm ms-2"
                                            onClick={() => handleSave()}
                                        >
                                            <i className="bi bi-floppy"></i> Save
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm ms-2"
                                            onClick={() => handleModify()}
                                        >
                                            <i className="bi bi-pencil"></i> Edit
                                        </button>
                                    )}
                                    <AddCustomization customValue={customValue} updateCustomization={handleCustomAdd}/>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-center">


            </div>
        </>
    );
}

export default CustomizationForm;
